import React, { useEffect, useState } from "react";
import MenuItem from "../../components/admin/menu/MenuItem";
import { useDocumentTitle } from "../../hooks";
import BackendLayout from "../../layouts/BackendLayout";
import { useDispatch } from "react-redux";
import { getTenkenTopPageSettings } from "../../api/setting/pageApi";
import { setPageSettings } from "../../store/actions/pageActions";
import { clearPageLoading } from "../../store/actions";
import {DASHBOARD_PAGE} from "../../constants/pageName";
import useRedirectPage from "../../hooks/useRedirectPage";
import {RedirectAlert} from "../../components";

const TopPage = () => {
  useRedirectPage(DASHBOARD_PAGE);
  const [menuItems, setMenuItems] = useState([]);
  const dispatch = useDispatch();
  useDocumentTitle("TOP - 点検王");

  //Function help to set page settings
  const setTopPageSettings = async (e) => {
    const pageSettings = await getTenkenTopPageSettings();
    dispatch(setPageSettings(pageSettings));
    setMenuItems(pageSettings.menu_items);
    dispatch(clearPageLoading());
  };

  useEffect(() => {
    setTopPageSettings();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <BackendLayout breadcrumb={{}} page="top">
      <div className="pt-[16px]">
        <RedirectAlert />
      </div>
      <div className="grid grid-cols-3 gap-x-7 gap-y-7 2xl:gap-y-10 py-10 lg:px-8 lg:py-20 xl:px-40 xl:py-14 2xl:px-52 2xl:py-28 max-w-[1460px] mx-auto">
        {menuItems.map((item, index) => {
          if (item.hasOwnProperty("access") && item.access === false) {
            return null;
          }
          return <MenuItem key={index} menu={item.name} />;
        })}
      </div>
    </BackendLayout>
  );
};

export default TopPage;
